<div #contentWrapper [hidden]="readonly">
  <ng-content></ng-content>
</div>

<div #readOnlyContentWrapper>
  @if (!!readonly) {
    <mad-readonly-form-field
      [label]="getLabel()"
      [value]="value"
      [textAlign]="textAlign"
      [formatNumber]="formatNumber"
      [decimalPlaces]="decimalPlaces"
      [roundDisplayValue]="roundValue"
      [autofillDecimals]="autofillDecimals"
      [unit]="unit"
      [unitPosition]="unitPosition"
      [errorMessage]="errorMessage"
      [multiline]="multiline"
      [rows]="rows"
      [shrinkIfEmpty]="shrinkIfEmpty"
      [id]="id"
      [suffix]="suffix"
      [prefix]="prefix"
      [multilineAutoSize]="multilineAutoSize"
      (suffixClickedEmitter)="suffixClicked()"
      (prefixClickedEmitter)="prefixClicked()"
    >
    </mad-readonly-form-field>
  }
</div>
